export enum CompetitionCategoryType {
  League = 1,
  IndoorCup = 2,
  Tournament = 3,
  OutdoorCup = 4,
  Relegation = 5,
}
